export default {
    attachment: "/gateway/huilianApi/uploader/attachment", // 图片上传
    h5: {
        ocrIDCard: "/gateway/huilianCust/realCustcs/ocrIDCard", // 身份证OCR识别
    },
    wechat: {
        ocrIDCard: "/gateway/huilianCust/realCustcs/ocrIDCard", // 身份证OCR识别
    },
};



// WEBPACK FOOTER //
// ./src/authCertificate/modules/papersUpload_GR/api.js